import PropTypes from "prop-types";
import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { isAnswered } from "../../../../utils/QuestionUtils";
import QuestionHeader from "./QuestionHeader";
import UploadRenderer from "./renderer/UploadRenderer";

/**
 * Upload question component for survey-view.
 */
const UploadQuestion = ({
  question,
  questionAnswer,
  validation,
  removeQuestionAnswer,
  row,
  column,
  uploadFiles,
  downloadFile,
  selectFiles
}) => {
  return (
    <Row>
      <Col sm={12} md={12} lg={12}>
        <QuestionHeader
          question={question}
          answered={isAnswered(question, questionAnswer)}
          validation={validation}
          showOnlyError={true}
        >
          <UploadRenderer
            question={question}
            questionAnswer={questionAnswer}
            removeQuestionAnswer={removeQuestionAnswer}
            row={row}
            column={column}
            uploadFiles={uploadFiles}
            downloadFile={downloadFile}
            selectFiles={selectFiles}
            validation={validation}
          />
        </QuestionHeader>
      </Col>
    </Row>
  );
};

UploadQuestion.propTypes = {
  question: PropTypes.object,
  questionAnswer: PropTypes.object,
  addQuestionAnswer: PropTypes.func,
  uploadFiles: PropTypes.func,
  downloadFile: PropTypes.func,
  validation: PropTypes.object,
  showOnlyError: PropTypes.bool
};

export default UploadQuestion;
